export default function DashBoardIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16667 1.33333C2.16667 0.873096 1.79357 0.5 1.33333 0.5C0.873096 0.5 0.5 0.873096 0.5 1.33333V14.6667C0.5 15.1269 0.873096 15.5 1.33333 15.5H14.6667C15.1269 15.5 15.5 15.1269 15.5 14.6667C15.5 14.2064 15.1269 13.8333 14.6667 13.8333H2.16667V1.33333ZM16.1667 4.75C16.4428 4.38181 16.3682 3.85948 16 3.58333C15.6318 3.30719 15.1095 3.38181 14.8333 3.75L11.6598 7.98133L7.75592 4.07741C7.45116 3.77265 6.96428 3.75056 6.63318 4.02648L4.13318 6.10982C3.77962 6.40445 3.73185 6.92992 4.02648 7.28349C4.32112 7.63705 4.84659 7.68482 5.20015 7.39018L7.11553 5.79404L11.1607 9.83926C11.3316 10.0101 11.5681 10.0984 11.8091 10.0812C12.05 10.0641 12.2717 9.94326 12.4167 9.75L16.1667 4.75Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
